import { request, dataMap } from '../../../../common/utility/fetch'
import {
  checkInPending,
  checkInSuccess,
  checkInFailure,
  CheckInJsonResponse,
} from '.'
import configuration from '../../../../configuration'
import { AppThunk, RootState } from '../../../store'
import { updateUserStatistic } from '../../Auth'
import { CheckInParams, CheckIn } from '.'

const statisticKeysDictionary = {
  badgeUrlLarge: 'badge_url_large',
  badgeUrlSmall: 'badge_url_small',
  badgeUrl: 'badge_url',
  checkinsCount: 'checkins_count',
  enrollmentStatus: 'enrollment_status',
  level: 'level',
  nextBadgeUrl: 'next_badge_url',
  nextBadgeUrlLarge: 'next_badge_url_large',
  nextBadgeUrlSmall: 'next_badge_url_small',
  nextLevel: 'next_level',
  nextLevelCheckinsRequired: 'next_level_checkins_required',
  nextLevelReferralsRequired: 'next_level_referrals_required',
  points: 'points',
  pointsPerCheckin: 'points_per_checkin',
  referralsCount: 'referrals_count',
}

const checkInUser = async (
  args: CheckInParams,
  authToken: string,
): Promise<CheckIn> => {
  const baseUrl = configuration.onlinePlatformApi
  const endpoint = '/workout-library/checkins'
  const method = 'POST'
  const body = JSON.stringify({
    type: 'ONDEMAND',
    userId: args.userId,
    workoutId: args.workoutId.toString(),
  })
  const response = await request({ baseUrl, endpoint, body, authToken, method })
  const responseJSON: CheckInJsonResponse = await response.json()
  return response.ok
    ? responseJSON
    : Promise.reject(new Error(responseJSON.message))
}

export const checkIn =
  (args: CheckInParams): AppThunk =>
  async (dispatch, getState) => {
    const state = getState() as RootState
    const authToken = state.auth?.user?.auth_token || ''
    dispatch(checkInPending(true))
    try {
      const response = await checkInUser(args, authToken)
      const translatedStats = dataMap(
        statisticKeysDictionary,
        response.statistic,
      )
      dispatch(updateUserStatistic(translatedStats))
      dispatch(checkInSuccess())
    } catch (error: any) {
      const errorMessage = error.message
        ? error.message
        : 'An unknown error occurred'
      dispatch(checkInFailure(errorMessage))
    }
  }
